/* Impact Stats - detail popups. Native <dialog> for the focus trap and
   Escape handling; the open attribute is observed because the close event is
   unreliable across browsers. */
(function () {
  'use strict';
  function init(scope) {
    var roots = (scope || document).querySelectorAll('.hp-stats');
    [].slice.call(roots).forEach(function (root) {
      if (root.hpStats) return;
      root.hpStats = true;

      root.addEventListener('click', function (e) {
        var opener = e.target.closest ? e.target.closest('[data-stat-dialog]') : null;
        if (opener) {
          var d = document.getElementById(opener.getAttribute('data-stat-dialog'));
          if (!d) return;
          d.statOpener = opener;
          if (d.showModal) d.showModal();
          else d.setAttribute('open', '');
          return;
        }
        var closer = e.target.closest ? e.target.closest('[data-stat-close]') : null;
        if (closer) {
          var dc = closer.closest('dialog');
          if (dc) { if (dc.close) dc.close(); else dc.removeAttribute('open'); }
        }
      });

      [].slice.call(root.querySelectorAll('.hp-stats__dialog')).forEach(function (d) {
        d.addEventListener('click', function (e) { if (e.target === d && d.close) d.close(); });
        if (window.MutationObserver) {
          new MutationObserver(function () {
            if (d.hasAttribute('open')) return;
            if (d.statOpener && d.statOpener.focus) d.statOpener.focus();
          }).observe(d, { attributes: true, attributeFilter: ['open'] });
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
